/**
 * Shared Badge Type Definitions
 *
 * This file is shared between:
 * - src/badgeService.js (frontend, ES6 modules)
 * - scripts/manageBadges.js (Node.js script, CommonJS)
 *
 * STYLING GUIDELINES - All user achievement badges follow this pattern:
 * - color: Use light gradient (50-50 shades): 'from-{color}-50 to-{color2}-50'
 * - borderColor: Use medium shade (400): 'border-{color}-400'
 * - textColor: Use darker shade (700): 'text-{color}-700'
 * - icon: Single emoji character
 * - Size/spacing (compact): px-1.5 py-0.5, border, rounded-full, text-[11px], icon text-xs
 *   (Note: User badges are smaller than OrgVerificationBadge for visual hierarchy)
 *
 * RESPONSIVE DESIGN:
 * - Badge labels truncate on narrow screens (max-w-[100px] on mobile, full on desktop)
 * - Tooltips left-align on mobile, center-align on desktop to prevent overflow
 * - Tooltips use responsive width (90vw on mobile, max 280px)
 *
 * Example color schemes:
 * - Gold/Yellow: from-yellow-50 to-amber-50, border-yellow-400, text-yellow-700
 * - Silver/Gray: from-slate-50 to-gray-50, border-slate-400, text-slate-700
 * - Bronze/Orange: from-orange-50 to-amber-50, border-orange-400, text-orange-700
 * - Blue: from-blue-50 to-indigo-50, border-blue-400, text-blue-700
 * - Purple: from-purple-50 to-violet-50, border-purple-400, text-purple-700
 * - Green: from-green-50 to-emerald-50, border-green-400, text-green-700
 * - Red: from-red-50 to-rose-50, border-red-400, text-red-700
 */

const BADGE_TYPES = {
  top_1_percent_commenter: {
    label: 'Top 1% Commenter',
    description: 'The most active and helpful community members',
    icon: '🏆',
    color: 'from-yellow-50 to-amber-50',
    borderColor: 'border-yellow-400',
    textColor: 'text-yellow-700'
  },
  top_5_percent_commenter: {
    label: 'Top 5% Commenter',
    description: 'Highly active and valued community member',
    icon: '🥈',
    color: 'from-slate-50 to-gray-50',
    borderColor: 'border-slate-400',
    textColor: 'text-slate-700'
  },
  top_10_percent_commenter: {
    label: 'Top 10% Commenter',
    description: 'Active and engaged community member',
    icon: '🥉',
    color: 'from-orange-50 to-amber-50',
    borderColor: 'border-orange-400',
    textColor: 'text-orange-700'
  },
  top_25_percent_commenter: {
    label: 'Top 25% Commenter',
    description: 'Engaged contributor to the community',
    icon: '⭐',
    color: 'from-blue-50 to-indigo-50',
    borderColor: 'border-blue-400',
    textColor: 'text-blue-700'
  }
  // Add more badge types here following the styling guidelines above
};

// Export for ES6 modules (frontend)
export { BADGE_TYPES };

// Export for CommonJS (Node.js scripts)
if (typeof module !== 'undefined' && module.exports) {
  module.exports = { BADGE_TYPES };
}
